module.exports = __webpack_public_path__ + "img/selected5-min.f40936cd.png";